<script>
  import VideoCard from "./VideoCard.svelte";
  import list from "../../../public/scratchItems.js";

  let i = 1;
  list.forEach(item => {
    item["id"] = i;
    i++;
  });
</script>

<style>
  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(25rem, 1fr));
    grid-auto-rows: 8rem;
    gap: 1em;
    list-style: none;
    padding: 0;
  }

  @media screen and (max-width: 1100px) {
	  .grid{
		  gap:0.4em;
	  }
  }
</style>

<div class="grid">
  {#each list as card}
    <VideoCard {card} />
  {/each}

</div>
